export default "__VITE_ASSET__rvcDnZX6__"